var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alt arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0811 10.3367L10.3087 13.1956C10.131 13.3788 9.86891 13.3788 9.69133 13.1956L4.33325 7.67026C3.99891 7.32543 4.20158 6.66634 4.64191 6.66634H9.41075L13.0811 10.3367Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5894 6.66628H15.3582C15.7986 6.66628 16.0013 7.32545 15.6669 7.6702L13.6614 9.73828L10.5894 6.66628Z",
    fill: "#AAAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.e023c5100e48a3303cc206650eaf3c9d.svg";
export { ForwardRef as ReactComponent };